import { PureComponent } from "react";

import { TriggerButton } from "widgets";

import ParentEditingDialog from "./ParentEditingDialog.js";
import { ModalActionWidget } from "./overlays/index.js";

export interface IParentEditingButtonProps {
  viewType: string;
  summaryPageEntity: { id: number; groupType: string };
}

class ParentEditingButton extends PureComponent<IParentEditingButtonProps> {
  render() {
    return (
      <ModalActionWidget
        title={"Export"}
        actionWidget={({ open }) => (
          <TriggerButton id={"parent-editing-button"} icon={"edit"} onPress={() => open()} label={"Edit"} showLabel />
        )}
      >
        {({ close }) => (
          <ParentEditingDialog
            viewType={this.props.viewType}
            summaryPageEntity={this.props.summaryPageEntity}
            close={close}
          />
        )}
      </ModalActionWidget>
    );
  }
}

export default ParentEditingButton;
